<sc-data-set-tile>
    <div class="tile">
        <sc-flex [centered]="true" fitHeight>
          <img [src]="url" width="100%"/>
        </sc-flex>

    </div>
</sc-data-set-tile>
